import * as React from "react";

const SvgFeatureCheckboxSelected = (props) => (
  <svg
    width={31}
    height={31}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={15.5} cy={15.5} r={15.5} fill="currentColor" />
    <path
      d="M13 23.2a.804.804 0 0 1-.566-.234l-4.8-4.8a.8.8 0 0 1 1.13-1.13L13 21.268l10.633-10.634a.8.8 0 0 1 1.131 1.131l-11.2 11.2a.797.797 0 0 1-.566.234H13Z"
      fill="#ffffff"
    />
  </svg>
);

export default SvgFeatureCheckboxSelected;
